import { render } from "./ChatCommandPalette.vue?vue&type=template&id=4d2c1f14"
import script from "./ChatCommandPalette.vue?vue&type=script&lang=js"
export * from "./ChatCommandPalette.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__